import React from 'react';

const iconProps = (size = 20) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.9,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
});

// Bare tick for completed steps. Icons.js has a filled IconCheckCircle, but it
// is drawn on a 16px filled grid and reads heavier than everything around it in
// the stepper, so the marker uses this stroked one instead.
export const IconCheck = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

export const IconBriefcase = (props) => (
  <svg {...iconProps(20)} {...props}>
    <rect x="3" y="7" width="18" height="13" rx="2" />
    <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
    <path d="M3 12h18" />
  </svg>
);

export const IconBuilding = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M4 20V6l8-3 8 3v14" />
    <path d="M10 20v-5h4v5" />
    <path d="M8 9h.01M12 9h.01M16 9h.01M8 12h.01M12 12h.01M16 12h.01" />
  </svg>
);

export const IconServer = (props) => (
  <svg {...iconProps(20)} {...props}>
    <rect x="3" y="4" width="18" height="5" rx="1.5" />
    <rect x="3" y="10" width="18" height="5" rx="1.5" />
    <rect x="3" y="16" width="18" height="4" rx="1.5" />
    <path d="M7 6.5h.01M7 12.5h.01M7 18h.01" />
  </svg>
);

export const IconDiagram3 = (props) => (
  <svg {...iconProps(20)} {...props}>
    <rect x="10" y="3" width="4" height="4" rx="1" />
    <rect x="3" y="16" width="4" height="4" rx="1" />
    <rect x="10" y="16" width="4" height="4" rx="1" />
    <rect x="17" y="16" width="4" height="4" rx="1" />
    <path d="M12 7v4M12 11H5M12 11h7" />
  </svg>
);

export const IconHash = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M9 4 7 20M17 4l-2 16M4 9h16M3 15h16" />
  </svg>
);

export const IconLink45deg = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M10 14 8 16a3 3 0 1 1-4-4l2-2" />
    <path d="M14 10l2-2a3 3 0 1 1 4 4l-2 2" />
    <path d="m9 15 6-6" />
  </svg>
);

export const IconArrowRight = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M4 12h14" />
    <path d="m13 7 5 5-5 5" />
  </svg>
);

export const IconArrowLeft = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M20 12H6" />
    <path d="m11 7-5 5 5 5" />
  </svg>
);

export const IconSearch = (props) => (
  <svg {...iconProps(20)} {...props}>
    <circle cx="11" cy="11" r="6" />
    <path d="m20 20-3.5-3.5" />
  </svg>
);

export const Icon123 = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M5 8h2v8M11 8h3a2 2 0 1 1 0 4h-3m0 0h3a2 2 0 1 1 0 4h-3M19 10a2 2 0 1 0-3-1.7" />
  </svg>
);

export const IconLightbulb = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M9 18h6M10 22h4" />
    <path d="M12 2a7 7 0 0 1 4.8 12.1c-.9.9-1.8 1.8-1.8 3.4h-6c0-1.6-.9-2.5-1.8-3.4A7 7 0 0 1 12 2Z" />
  </svg>
);

export const IconInfoCircle = (props) => (
  <svg {...iconProps(20)} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 10v6M12 7h.01" />
  </svg>
);

export const IconExclamationCircle = (props) => (
  <svg {...iconProps(20)} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v5M12 16h.01" />
  </svg>
);

export const IconFileText = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
    <path d="M14 3v5h5M9 12h6M9 16h6" />
  </svg>
);

export const IconBank = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M3 9h18M4 9l8-5 8 5M6 9v8M10 9v8M14 9v8M18 9v8M3 20h18" />
  </svg>
);

export const IconTags = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M7 6h8l4 4-8 8-8-8V6Z" />
    <path d="M11 10h.01" />
    <path d="M3 10V6a2 2 0 0 1 2-2h4" />
  </svg>
);

export const IconX = (props) => (
  <svg {...iconProps(18)} {...props}>
    <path d="m6 6 12 12M18 6 6 18" />
  </svg>
);

export const IconPlus = (props) => (
  <svg {...iconProps(18)} {...props}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const IconGear = (props) => (
  <svg {...iconProps(20)} {...props}>
    <circle cx="12" cy="12" r="3.2" />
    <path d="M19.4 15a1 1 0 0 0 .2 1.1l.1.1a1 1 0 0 1 0 1.4l-1.2 1.2a1 1 0 0 1-1.4 0l-.1-.1a1 1 0 0 0-1.1-.2 1 1 0 0 0-.6.9V21a1 1 0 0 1-1 1h-1.8a1 1 0 0 1-1-1v-.2a1 1 0 0 0-.6-.9 1 1 0 0 0-1.1.2l-.1.1a1 1 0 0 1-1.4 0l-1.2-1.2a1 1 0 0 1 0-1.4l.1-.1a1 1 0 0 0 .2-1.1 1 1 0 0 0-.9-.6H3a1 1 0 0 1-1-1v-1.8a1 1 0 0 1 1-1h.2a1 1 0 0 0 .9-.6 1 1 0 0 0-.2-1.1l-.1-.1a1 1 0 0 1 0-1.4l1.2-1.2a1 1 0 0 1 1.4 0l.1.1a1 1 0 0 0 1.1.2 1 1 0 0 0 .6-.9V3a1 1 0 0 1 1-1h1.8a1 1 0 0 1 1 1v.2a1 1 0 0 0 .6.9 1 1 0 0 0 1.1-.2l.1-.1a1 1 0 0 1 1.4 0l1.2 1.2a1 1 0 0 1 0 1.4l-.1.1a1 1 0 0 0-.2 1.1 1 1 0 0 0 .9.6h.2a1 1 0 0 1 1 1v1.8a1 1 0 0 1-1 1h-.2a1 1 0 0 0-.9.6Z" />
  </svg>
);

export const IconFileEarmarkCode = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
    <path d="M14 3v5h5M11 13l-2 2 2 2M15 13l2 2-2 2" />
  </svg>
);

export const IconEye = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const IconShieldCheck = (props) => (
  <svg {...iconProps(20)} {...props}>
    <path d="M12 3 5 6v6c0 5 3.4 8.4 7 9 3.6-.6 7-4 7-9V6l-7-3Z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

